import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetWishListApiParameter } from "@insite/client-framework/Services/WishListService";
import { chain, CreateDataForUnparse } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    { wishListId: string },
    {
        apiParameter: GetWishListApiParameter;
        apiResult: WishListModel;
        pricingLoaded?: true;
        dataForUnparse: { fields: Array<any>; data: string | Array<any> };
    }
>;

export const CreateDataForUnparseExtended: HandlerType = props => {
    const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        return;
    }


    props.dataForUnparse = {
        fields: [
            translate("Item #"),
            translate("MFG #"),
            translate("Customer Part #"),
            translate("Quantity"),
            translate("Unit of Measure"),
            translate("Brand"),
            translate("Title"),
            translate("Price"),
            translate("Notes"),
            translate("HESCO Availability"),
            translate("Manufacturer Availability"),
            translate("Added on"),
            translate("Added by"),
            
        ],
        data: wishListLineCollection.map(o => [
            o.erpNumber,
            o.manufacturerItem,
            o.properties?.customerPartNumber,
            o.qtyOrdered.toString(),
            o.unitOfMeasure,
            o.brand?.name || "",
            o.shortDescription,
            o.quoteRequired ? "" : o.pricing?.unitRegularPrice?.toString() || "",
            o.notes,
            o.properties?.hescoAvailability,
            o.properties?.manufacturerAvailability,
            o.createdOn.toString(),
            o.createdByDisplayName,
        ]),
    };
};



replaceInChain(chain, CreateDataForUnparse, CreateDataForUnparseExtended);